import KanBoIcon from 'components/KanBoIcon'
import { ModalBoardContext, ModalCardContext } from 'components/Modal'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { useCardContext } from 'dataProviders/Card'
import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import Element from '../Element'
import {
  MenuItem
} from 'components/Menu'
import { useBoardContext, useBoardPermission } from 'dataProviders/Board'
import { FormattedMessage } from 'react-intl'
import DocumentFolderCreatorSettings from './DocumentFolderCreatorSettings'
import { KanBoLink } from 'components/Link'
import SelectedDocumentFolder from '../SelectedDocumentFolder'
import { ViewBody } from 'components/Sidebar'
import {
  ControlLabel,
} from 'react-bootstrap'

const TypedElement: any = Element

const DocumentFolderCreator = React.forwardRef<typeof TypedElement, LeftSidebarProps & {
  id: number;
  sortable: any;
}>(({
  leftSidebar,

  id,
  sortable,
}, ref) => {  
  const cardContext = useCardContext()

  const boardContext = useBoardContext()

  const permission = useBoardPermission()

  const documentSourceId = useSelector<any, number>(state => state['view-card'].elements.elementsById[id]?.documentSourceId)

  const path = useSelector<any, string>(state => state['view-card'].elements.elementsById[id]?.path)

  const fullUrl = useSelector<any, string>(state => state['view-card'].elements.elementsById[id]?.fullUrl)

  const isCardArchived = useSelector<any, string>(state => state['view-board'].cards[cardContext.id].isArchived)

  const handleSettingsClick = useCallback(() => {
    leftSidebar.push(() =>
      <ModalBoardContext boardId={boardContext.id}>
        <ModalCardContext cardId={cardContext.id}>
          <DocumentFolderCreatorSettings elementId={id} />
        </ModalCardContext>
      </ModalBoardContext>
    )
  }, [id, boardContext.id, cardContext.id])

  const handleGoToSourceClick = useCallback(() => {
    window.open(fullUrl, '_blank')
  }, [fullUrl])

  const menu = useMemo(() => {
    const menu = [
      <MenuItem
        key='go-to-source'
        icon={<KanBoIcon name='kanbo-16-go-to-source' />}
        onClick={handleGoToSourceClick}
      >
        <FormattedMessage id='DOCUMENTS_SOURCE_GO_TO' />
      </MenuItem>
    ]

    if (!isCardArchived && permission.member) {
      menu.push(
        <MenuItem
          key='settings'
          icon={<KanBoIcon name='kanbo-16-settings' />}
          onClick={handleSettingsClick}
        >
          <FormattedMessage id='SETTINGS' />
        </MenuItem>
      )
    }

    return menu
  }, [isCardArchived, permission.member, handleGoToSourceClick, handleSettingsClick])

  return (
    <TypedElement
      ref={ref}
      id={id}
      icon={<KanBoIcon name='kanbo-24-document-folder-new' />}
      sortable={sortable}
      menu={menu}
      nameInfo={
        <KanBoLink href={fullUrl}>{fullUrl}</KanBoLink>
      }
    >
      <ViewBody>
        <ControlLabel><FormattedMessage id='DOCUMENT_FOLDER_CREATOR_SELECTED_SOURCE' /></ControlLabel>
        <SelectedDocumentFolder
          documentSourceId={documentSourceId}
          path={path}
        />
      </ViewBody>
    </TypedElement>
  )
})

export default withLeftSidebar(DocumentFolderCreator)
